import { Button } from "@/components/ui/button";
import { Phone, Mail, MapPin, MessageCircle, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { COMPANY } from "@/data/content";

export default function ContactCTA({ onOpenDemo }) {
  return (
    <section className="relative py-24 lg:py-32" data-testid="home-contact-cta">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.6 }}
          className="relative overflow-hidden rounded-[32px] p-8 sm:p-12 lg:p-16 bg-[#0B1224] border border-white/10"
        >
          <div className="absolute inset-0 hero-glow opacity-70" aria-hidden />
          <div className="absolute inset-0 grid-bg opacity-30" aria-hidden />
          <div className="relative grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7">
              <div className="overline">Ready to launch?</div>
              <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter leading-none">
                Talk to our <span className="text-gradient-blue">solutions team</span>.
              </h2>
              <p className="mt-5 text-gray-400 max-w-xl leading-relaxed">
                Free consultation. No obligations. Get a customised proposal, a demo of the platform and a launch roadmap for your jurisdiction.
              </p>
              <div className="mt-8 flex flex-wrap gap-3">
                <Button
                  data-testid="contact-cta-book-demo"
                  onClick={onOpenDemo}
                  className="btn-glow bg-[#2563EB] hover:bg-[#1d4ed8] rounded-full h-12 px-7"
                >
                  Book a Demo <ArrowRight className="ml-2 w-4 h-4"/>
                </Button>
                <a
                  href="https://wa.me/447577308890"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="contact-cta-whatsapp"
                  className="inline-flex items-center gap-2 h-12 px-6 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 text-sm font-medium"
                >
                  <MessageCircle className="w-4 h-4"/> WhatsApp
                </a>
              </div>
            </div>

            <div className="lg:col-span-5 grid gap-4">
              <div className="p-5 rounded-2xl glass flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-[#2563EB]/20 border border-[#2563EB]/40 flex items-center justify-center">
                  <MapPin className="w-5 h-5 text-[#00D4FF]" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-[0.2em] text-gray-500">Office</div>
                  <div className="mt-1 text-sm">{COMPANY.address}</div>
                </div>
              </div>
              <div className="p-5 rounded-2xl glass flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-[#2563EB]/20 border border-[#2563EB]/40 flex items-center justify-center">
                  <Phone className="w-5 h-5 text-[#00D4FF]" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-[0.2em] text-gray-500">Phone</div>
                  <a href={`tel:${COMPANY.phone}`} className="mt-1 text-sm hover:text-white">{COMPANY.phone}</a>
                </div>
              </div>
              <div className="p-5 rounded-2xl glass flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-[#2563EB]/20 border border-[#2563EB]/40 flex items-center justify-center">
                  <Mail className="w-5 h-5 text-[#00D4FF]" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-[0.2em] text-gray-500">Email</div>
                  <a href={`mailto:${COMPANY.email}`} className="mt-1 text-sm hover:text-white">{COMPANY.email}</a>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
